import { Element, QuestionVariablePurpose, SchemaType, SurveyVariableDefinition, SurveyVariables } from '@hyper-inferno/survey-elements-core';

export class SurveyVariableCollectionBuilder {
  private variables: SurveyVariables = {};

  addVariable(key: string, definition: SurveyVariableDefinition): this {
    if (this.variables[key]) {
      throw new Error(`Variable with key '${key}' already exists.`);
    }
    this.variables[key] = definition;
    return this;
  }

  updateVariable(
    key: string,
    updatedFields: Partial<SurveyVariableDefinition>,
  ): this {
    if (!this.variables[key]) {
      throw new Error(`Variable with key '${key}' does not exist.`);
    }
    this.variables[key] = {
      ...this.variables[key],
      ...updatedFields,
    };
    return this;
  }

  removeVariable(key: string): this {
    if (!this.variables[key]) {
      throw new Error(`Variable with key '${key}' does not exist.`);
    }
    delete this.variables[key];
    return this;
  }

  getVariable(key: string): SurveyVariableDefinition | undefined {
    return this.variables[key];
  }

  addSkipVariableIfApplicable(question: Element) {
    // return this.addVariableIfApplicable(
    //   `${question.name}_is_skipped`,
    //   {
    //     label: `${question.name} Skipped?`,
    //     questionId: question.id,
    //     schema: { type: SchemaType.boolean, default: false },
    //     purpose: QuestionVariablePurpose.isSkipped,
    //   },
    //   question.is_skippable ?? false,
    // );
    // .addLocationVariableIfApplicable(question)
    // .addPageTimeVariable(question);
  }
  // addLocationVariableIfApplicable(question: Element) {
  //   return this.addVariableIfApplicable(
  //     `${question.name}_latlng`,
  //     {
  //       label: `${question.name} LatLng`,
  //       questionId: question.id,
  //       schema: { type: SchemaType.string, default: undefined },
  //       purpose: QuestionVariablePurpose.latlng,
  //     },
  //     question.captureLocation,
  //   ).addVariableIfApplicable(
  //     `${question.name}_location_name`,
  //     {
  //       label: `${question.name} Location Name`,
  //       questionId: question.id,
  //       schema: { type: SchemaType.string, default: undefined },
  //       purpose: QuestionVariablePurpose.location_name,
  //     },
  //     question.captureLocation,
  //   );
  // }

  addVariableIfApplicable(
    key: string,
    definition: SurveyVariableDefinition,
    isApplicable: boolean,
  ) {
    if (isApplicable) this.addVariable(key, definition);
    return this;
  }

  // addPageTimeVariable(question: Element) {
  //   return this.addVPageTime(
  //     `${question.name}_pageTime`,
  //     {
  //       label: `${question.name} Page time`,
  //       questionId: question.id,
  //       schema: { type: SchemaType.number, default: 0 },
  //       purpose: QuestionVariablePurpose.pageTime,
  //     },
  //     question.pageType,
  //   );

  //   return this.addVariable(`${question.name}_pageTime`)
  // }

  addVPageTime(
    key: string,
    definition: SurveyVariableDefinition,
    pageType: string | undefined,
  ): this {
    if (pageType === 'Question') this.addVariable(key, definition);
    return this;
  }

  // async addCustomVariables(
  //   variables: Variable[],
  //   variableUtilService: any,
  //   question?: Question
  // ) {
  //   await Promise.all(
  //     variables.map(async (variable: Variable) => {
  //       if (variable.variableCellType == 'multiple_choice') {
  //         const mainList = await variableUtilService.getListByListId(
  //           variable.variableListId
  //         );
  //         mainList.options.forEach((option: Option) => {
  //           this.addVariable(
  //             multiple_option_questionLabel(
  //               variable.variableKey,
  //               option.optionKey
  //             ),
  //             {
  //               label: `${multiple_option_questionLabel(
  //                 variable.variableKey,
  //                 option.optionKey
  //               )} - ${option.optionDisplay} - ${variable.variableDisplay}`,
  //               questionId: question?.id,
  //               schema: {
  //                 type: SchemaType.integer,
  //                 // default: 0,
  //                 default: undefined,
  //                 valueLabels: { 0: 'unchecked', 1: 'checked' },
  //               },
  //               purpose: QuestionVariablePurpose.RESPONSE,
  //               optionAssociation: {
  //                 mainOptionKey: option.optionKey,
  //               },
  //               variableAssociation: variable,
  //             }
  //           );
  //         });
  //       } else if (variable.variableCellType == 'single_choice') {
  //         const mainList = await variableUtilService.getListByListId(
  //           variable.variableListId
  //         );
  //         const valueLabels = mainList.options.reduce(
  //           (acc: string[], option: Option) => {
  //             acc[option.optionKey] = option.optionDisplay;
  //             return acc;
  //           },
  //           {}
  //         );

  //         this.addVariable(variable_name(variable.variableKey), {
  //           label: `${variable_name(variable.variableKey)} - ${
  //             variable.variableDisplay
  //           }`,
  //           questionId: question?.id,
  //           schema: {
  //             type: SchemaType.integer,
  //             default: undefined,
  //             valueLabels: valueLabels,
  //           },
  //           purpose: QuestionVariablePurpose.RESPONSE,
  //           variableAssociation: variable,
  //         });
  //       } else if (variable.variableCellType == 'number') {
  //         this.addVariable(variable_name(variable.variableKey), {
  //           label: `${variable_name(variable.variableKey)} - ${
  //             variable.variableDisplay
  //           }`,
  //           questionId: question?.id,
  //           schema: { type: SchemaType.number, default: undefined },
  //           purpose: QuestionVariablePurpose.RESPONSE,
  //           variableAssociation: variable,
  //         });
  //       } else {
  //         this.addVariable(variable_name(variable.variableKey), {
  //           label: `${variable_name(variable.variableKey)} - ${
  //             variable.variableDisplay
  //           }`,
  //           questionId: question?.id,
  //           schema: { type: SchemaType.string, default: undefined },
  //           purpose: QuestionVariablePurpose.RESPONSE,
  //           variableAssociation: variable,
  //         });
  //       }
  //     })
  //   );
  //   return this;
  // }

  build(): SurveyVariables {
    return { ...this.variables };
  }
}
